export default "__VITE_ASSET__cb0a5ce9__"